import http from '@/utils/http';

const URL_BASE = '/regional';

export default {
    buscarRegionais() {
        return http.get({
            url: URL_BASE,
            lockScreen: false
        });
    }
};
